import React, { Component } from "react";

class CampaignReports extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return <div>Campaings</div>;
  }
}

export default CampaignReports;
